import React, { useState, useEffect, useCallback } from "react";
import { api } from "../../lib/api";

const HERO_VARIANT_LABELS = {
  a: { label: "A — Local & concret", h1: "Votre commerce mérite d'être trouvé par tous les habitants du Haut-Rhin." },
  b: { label: "B — Résultat & preuve", h1: "Plus d'appels. Plus de clients. Sans bouger de votre comptoir." },
  c: { label: "C — Problème → solution", h1: "Vos clients vous cherchent en ligne. Apparaissez avant les autres." },
};

export default function HeroAbPanel() {
  const [data, setData] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await api.get("/admin/hero-ab/stats");
      setData(r.data);
    } catch { /* noop */ }
  }, []);
  useEffect(() => {
    load();
    const itv = setInterval(load, 30000);
    return () => clearInterval(itv);
  }, [load]);
  if (!data) return <div className="text-sm text-muted-foreground">Chargement…</div>;
  const variants = data.variants || [];
  const totalImpr = variants.reduce((acc, v) => acc + (v.impressions || 0), 0);
  const totalClicks = variants.reduce((acc, v) => acc + (v.cta_clicks || 0), 0);
  const winner = variants.filter((v) => v.impressions >= 30).sort((a, b) => b.ctr_pct - a.ctr_pct)[0];

  return (
    <div data-testid="admin-hero-ab" className="space-y-6">
      <div className="bg-card border border-border rounded-sm p-6">
        <div className="label-uppercase mb-1">Test A/B/C — H1 page d&apos;accueil</div>
        <h2 className="font-display text-lg font-medium mb-2">Quelle accroche convertit le mieux ?</h2>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-2xl">
          Chaque visiteur (en français uniquement) voit aléatoirement l&apos;une des 3 versions, persistée pour sa session. On compte les impressions et les clics sur les CTA partenaire « Devenir partenaire ». Après ~100 impressions par variante, le CTR (clic-impressions) devient statistiquement significatif.
        </p>
        <div className="mt-3 text-xs text-muted-foreground">
          Total : <span className="font-semibold text-foreground tabular-nums">{totalImpr}</span> impressions ·{" "}
          <span className="font-semibold text-foreground tabular-nums">{totalClicks}</span> clics ·{" "}
          {totalImpr ? `${((totalClicks / totalImpr) * 100).toFixed(2)}% CTR moyen` : "Aucune donnée encore"}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {variants.map((v) => {
          const meta = HERO_VARIANT_LABELS[v.variant];
          const isWinner = winner && winner.variant === v.variant && totalImpr >= 90;
          return (
            <div key={v.variant} className={`bg-card border rounded-sm p-5 ${isWinner ? "border-primary border-2" : "border-border"}`} data-testid={`hero-ab-${v.variant}`}>
              <div className="flex items-start justify-between mb-2">
                <div className="label-uppercase">{meta.label}</div>
                {isWinner && <span className="text-[10px] font-bold uppercase tracking-widest bg-primary text-primary-foreground px-2 py-0.5 rounded-sm">★ Winner</span>}
              </div>
              <div className="text-sm font-display leading-snug mb-4 text-foreground">« {meta.h1} »</div>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div className="bg-accent/30 rounded-sm py-2">
                  <div className="text-[9px] uppercase tracking-widest text-muted-foreground font-bold">Impressions</div>
                  <div className="font-display text-lg tabular-nums font-medium">{v.impressions}</div>
                </div>
                <div className="bg-accent/30 rounded-sm py-2">
                  <div className="text-[9px] uppercase tracking-widest text-muted-foreground font-bold">Clics CTA</div>
                  <div className="font-display text-lg tabular-nums font-medium">{v.cta_clicks}</div>
                </div>
                <div className={`rounded-sm py-2 ${isWinner ? "bg-primary/10" : "bg-accent/30"}`}>
                  <div className="text-[9px] uppercase tracking-widest text-muted-foreground font-bold">CTR</div>
                  <div className={`font-display text-lg tabular-nums font-medium ${isWinner ? "text-primary" : ""}`}>{v.ctr_pct}%</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-xs text-muted-foreground italic">
        Conseil : laisse tourner ~2 semaines. Une fois un winner clair (CTR &gt; 30% au-dessus des autres et &gt;90 impressions cumulées), je peux verrouiller la variante gagnante en H1 par défaut.
      </div>
    </div>
  );
}
